module.exports = __webpack_public_path__ + "static/media/to-do-list.e884d46d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/to-do-list.svg
// module id = 1999
// module chunks = 32